import { SecondaryNavLinkTypes } from '@chegg-me-components/signed-out-header'; // SecondaryNavItem for educators

export var educatorsSecNavItem = {
  text: 'For educators',
  href: 'uversity',
  type: SecondaryNavLinkTypes.FOR_EDUCATOR
}; // SecondaryNavItem for sign-in

export var signInSecNavItem = {
  text: 'Sign in',
  href: 'login',
  type: SecondaryNavLinkTypes.SIGN_IN
}; // SecondaryNavItem for help

export var helpSecNavItem = {
  text: 'Help',
  href: 'contactus',
  type: SecondaryNavLinkTypes.HELP
};
export var secondaryNavLinks = [educatorsSecNavItem, helpSecNavItem, signInSecNavItem];
export default secondaryNavLinks;